import React from 'react';
import { Trans } from 'react-i18next';
import checkmarkIcon from 'presentation/assets/icons/png/3x/checkmark-red@3x.png';
import imageRef from 'presentation/assets/images/sa_feature.png';
import { TechemTheme } from '@techem/techem-theme';
import { Button } from '@techem/ui-components';
import { SIZE } from 'baseui/button';
import { Col, Row } from 'react-bootstrap';
import { useMediaQuery } from 'tools/hooks/useMediaQuery';
import Icon from './Icon';
import { minBreakpoints } from 'presentation/theme/mediaQueries';
import { TrackerUtil } from 'tracking/TrackerUtil';

const SAFeatureView = () => {
  const isAboveMd = useMediaQuery(`(min-width: ${minBreakpoints.md}px)`);
  const isAboveLg = useMediaQuery(`(min-width: ${minBreakpoints.lg}px)`);

  const onButtonClick = () => {
    window.location.href = `https://www.techem.com/de/de/geraete/rauchwarnmelder`;
  };

  return (
    <Row>
      <Col
        xs={12}
        className="mt-5 px-3 py-5"
        style={{
          backgroundColor: TechemTheme.colors.backgroundSecondary,
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          borderBottomLeftRadius: '8px',
          borderBottomRightRadius: '8px'
        }}
      >
        <Row className="my-3 justify-content-center">
          <Col
            xs={12}
            className="pb-3 ps-lg-0"
            style={{
              maxWidth: isAboveMd ? (isAboveLg ? '357px' : '410px') : '340px',
              paddingRight: isAboveLg ? '30px' : '15px'
            }}
          >
            <img
              className="mw-100 h-auto rounded-topleft rounded-bottomright"
              src={imageRef}
              alt="reading a book"
            />
          </Col>
          <Col xs={12} className="pe-md-0" style={{ maxWidth: isAboveMd ? '410px' : '340px' }}>
            <span className="copy">
              <Trans i18nKey="SAInfoBoxTitlePrefix" />
            </span>
            <h4 className="mt-2 mb-4">
              <Trans i18nKey="SAInfoBoxTitle" tOptions={{ skipPostProcessing: false }} />
            </h4>
            <ul className="ps-0" style={{ listStyle: 'none' }}>
              {Array.from({ length: 4 }, (_, i) => i + 1).map((index) => {
                return (
                  <li key={index}>
                    <Row>
                      <Col xs="auto" className="pe-0">
                        <Icon iconSrc={checkmarkIcon} alt="checkmark icon" centered />
                      </Col>
                      <Col xs style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                        <span className="copy">
                          <Trans
                            i18nKey={`SAInfoBoxBullet${index}`}
                            tOptions={{ skipPostProcessing: true }}
                          />
                        </span>
                      </Col>
                    </Row>
                  </li>
                );
              })}
            </ul>
            <Button
              onClick={() => {
                TrackerUtil.trackBtnClickByIdentifier('use-discount');
                onButtonClick();
              }}
              additionalTestId="use_discount"
              size={SIZE.large}
            >
              <Trans i18nKey="SAInfoBoxButtonText" />
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default SAFeatureView;
